import Discover1 from "./res/Discover Business Logos/1.png";
import Discover2 from "./res/Discover Business Logos/2.png";
import Discover3 from "./res/Discover Business Logos/3.png";
import Discover4 from "./res/Discover Business Logos/4.png";
import Discover5 from "./res/Discover Business Logos/5.png";
import Discover6 from "./res/Discover Business Logos/6.png";
import Discover7 from "./res/Discover Business Logos/7.png";
import Discover8 from "./res/Discover Business Logos/8.png";
import Discover9 from "./res/Discover Business Logos/9.png";
import Discover10 from "./res/Discover Business Logos/10.png";
import Discover11 from "./res/Discover Business Logos/11.png";

export const discoverData = [
    {
        img_src: Discover1
    },
    {
        img_src: Discover2
    },
    {
        img_src: Discover3
    },
    {
        img_src: Discover4
    },
    {
        img_src: Discover5
    },
    {
        img_src: Discover6
    },
    {
        img_src: Discover7
    },
    {
        img_src: Discover8
    },
    {
        img_src: Discover9
    },
    {
        img_src: Discover10
    },
    {
        img_src: Discover11
    },

];